import { Grid } from '@mui/material'
import { MidmarkTypography } from '@midmark-enterprise/shared-components'

export const NonFormikFormLayout = ({
    children,
    title,
    description,
    buttons,
}: {
    children: React.ReactNode | React.ReactNode[]
    title: string
    description?: string
    buttons?: React.ReactNode
}) => {
    return (
        <>
            <Grid
                sx={{
                    flex: 1,
                    '& > *:not(:last-child)': {
                        maxWidth: '100%',
                    },
                    paddingRight: 4,
                }}
                container
                wrap="nowrap"
                direction="column"
            >
                <MidmarkTypography
                    sx={{ mb: 3, mt: 1 }}
                    variant="h3"
                    data-testid={DATA_TESTIDS.formTitleTextField}
                >
                    {title}
                </MidmarkTypography>

                {description && (
                    <MidmarkTypography sx={{ mb: 3 }} variant="body1">
                        {description}
                    </MidmarkTypography>
                )}

                {children}

                {buttons && (
                    <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        justifyContent="space-between"
                        justifySelf="flex-end"
                        alignItems="center"
                        sx={{
                            marginTop: 'auto',
                            paddingTop: 2.5,
                            '& > *:last-child': { marginLeft: 'auto' },
                        }}
                    >
                        {buttons}
                    </Grid>
                )}
            </Grid>
        </>
    )
}

const DATA_TESTIDS = {
    formTitleTextField: 'form-title-text-field',
}
